import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0682f01d&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0682f01d')) {
      api.createRecord('0682f01d', component.options)
    } else {
      api.reload('0682f01d', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=0682f01d&", function () {
      api.rerender('0682f01d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Footer/footer.vue"
export default component.exports